<template>
  <div class="chat-container">
      <div class="chat-messages" ref="chatMessages">
          <div v-for="(message, index) in messages" :key="index">
            <div v-if="message.action == 'join'">
              <span>
                <em>
                  {{ message.data.content }}
                </em>
              </span>
            </div>
            <div v-if="message.action == 'left'">
              <span>
                <em>
                  {{ message.data.content }}
                </em>
              </span>
            </div>
            <div v-if="message.data.action == 'chat'">
              <span>
                <b>
                  {{ message.username }}: 
                </b>
                {{ message.data.content }}
              </span>
            </div>
          </div>
      </div>
      <form class="chat-input mb-0" @submit.prevent="sendMessage">
          <input 
              v-model="newMessage" 
              type="text" 
              id="message" 
              placeholder="Send Message" 
              :disabled="isApiCallInProgress"
              autocomplete="off"
              @focus="focusChat"
              @blur="blurChat"
              @keyup.stop
          >
          <button
              class="button m-0 bg-color text-light h-op-08"
              type="submit"
              :disabled="isApiCallInProgress"
          >
              <LoadingSpinner v-if="isApiCallInProgress" />
              <span v-else>Send</span>
          </button>
      </form>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import LoadingSpinner from '@/components/loading/LoadingSpinner.vue';
import { PropType } from 'vue';
import { LobbyMessage, sendSocketMessage } from '@/utils/ws';
import store, { DataStore, VuexModuleNamespaces } from '@/store';
import { getAnonymousUserId, getAnonymousUsername } from '@/utils/usernameTools';
import { emitCrosswordKeyEvent } from '@/service/crosswords';
import { fetchMobilePuzzleKeyboardPreferences } from '@/service/mobile';

@Options({
  components: {
      LoadingSpinner,
  },
  props: {
      socket: {
          required: true,
          type: Object as PropType<WebSocket>
      },
      messages: {
          required: true,
          type: Object as PropType<LobbyMessage[]>
      },
  }
})
export default class Chat extends Vue {
  
    socket!: WebSocket;
    messages!: LobbyMessage[];

    isApiCallInProgress = false;
    newMessage = '';

    sendMessage(): void {
        if (!this.newMessage.trim()) return;
        this.isApiCallInProgress = true;
        sendSocketMessage(this.socket, "chat", this.newMessage, this.userId, this.username);
        this.newMessage = '';
        this.isApiCallInProgress = false;
    }

    focusChat(): void {
      emitCrosswordKeyEvent("CLOSE");
    }

    blurChat(): void {
      if (this.isMobileKeyboardEligible()) {
        emitCrosswordKeyEvent("OPEN");
      }
    }

    isMobileKeyboardEligible(): boolean {
      if (fetchMobilePuzzleKeyboardPreferences()) {
        return true;
      } else {
        return false;
      }
    }

    get username(): string {
        const username = store.getters[`${VuexModuleNamespaces.App}/${DataStore.getters.getUsername.name}`];
        return username ? username : getAnonymousUsername();
    }

    get userId(): string {
        const username = store.getters[`${VuexModuleNamespaces.App}/${DataStore.getters.getUserId.name}`];
        return username ? username : getAnonymousUserId();
    }
  
    updated() {
        this.scrollToBottom();
    }

    scrollToBottom() {
        const chatMessages = this.$refs.chatMessages as HTMLElement;
        if (chatMessages) {
            chatMessages.scrollTop = chatMessages.scrollHeight;
        }
    }
}
</script>

<style scoped>
.chat-container {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 8px;
}
.chat-messages {
  height: 200px;
  overflow-y: auto;
  padding: 10px;
}
.chat-input {
  display: flex;
  padding: 10px;
}
.chat-input input {
  flex: 1;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-right: 10px;
}
.chat-input button {
  padding: 5px 15px;
  border: none;
  border-radius: 4px;
  background-color: #CE1785;
  color: #fff;
  cursor: pointer;
}
.chat-input button:hover {
  background-color: #14C90D;
}
</style>
